import React, { useContext } from "react"
import Pill from "@ui-kit/atoms/button/pill"


const Link = ({ title, link, mega = false, ...props }) => {

  const href = encodeURI(
    `${link || process.env.GATSBY_SALESFORCE_URL}`
  )
  //const href = encodeURI(`${process.env.SALESFORCE_URL}?props=${base64.encode(JSON.stringify(preferences))}`);

  return (
    <a
      {...props}
      target="_blank"
      rel="external noreferrer noopener"
      href={href}
    >
      <Pill elem="span" mega={mega} coloured>
        {title}
      </Pill>
    </a>
  )
}

export default Link